import { createIcon } from '@chakra-ui/react';

export const CloudDownloadHorizontal = createIcon({
  displayName: 'CloudDownload-Horizontal',
  viewBox: '0 0 24 24',
  path: (
    <g id="Download-Horizontal" transform="translate(10400 -3851)">
      <rect
        id="Rectangle_545"
        data-name="Rectangle 545"
        width="24"
        height="24"
        transform="translate(-10400 3851)"
        fill="#fff"
      />
      <g
        id="Group_3232"
        data-name="Group 3232"
        transform="translate(-14251 -6525) rotate(-90)"
      >
        <path
          id="Line_175"
          data-name="Line 175"
          d="M0,9.5a.479.479,0,0,1-.5-.455V-.045A.479.479,0,0,1,0-.5a.479.479,0,0,1,.5.455V9.045A.479.479,0,0,1,0,9.5Z"
          transform="translate(-10396.5 3851.5)"
          fill="currentColor"
        />
        <path
          id="Line_182"
          data-name="Line 182"
          d="M0,9.5a.479.479,0,0,1-.5-.455V-.045A.479.479,0,0,1,0-.5a.479.479,0,0,1,.5.455V9.045A.479.479,0,0,1,0,9.5Z"
          transform="translate(-10396.5 3865.5)"
          fill="currentColor"
        />
        <path
          id="Line_178"
          data-name="Line 178"
          d="M0,9.5a.479.479,0,0,1-.5-.455V-.045A.479.479,0,0,1,0-.5a.479.479,0,0,1,.5.455V9.045A.479.479,0,0,1,0,9.5Z"
          transform="translate(-10379.5 3851.5)"
          fill="currentColor"
        />
        <path
          id="Line_179"
          data-name="Line 179"
          d="M0,9.5a.479.479,0,0,1-.5-.455V-.045A.479.479,0,0,1,0-.5a.479.479,0,0,1,.5.455V9.045A.479.479,0,0,1,0,9.5Z"
          transform="translate(-10379.5 3865.5)"
          fill="currentColor"
        />
        <path
          id="Line_176"
          data-name="Line 176"
          d="M9.045.5H2.955A.479.479,0,0,1,2.5,0a.479.479,0,0,1,.455-.5H9.045A.479.479,0,0,1,9.5,0,.479.479,0,0,1,9.045.5Z"
          transform="translate(-10399.5 3851.5)"
          fill="currentColor"
        />
        <path
          id="Line_180"
          data-name="Line 180"
          d="M9.045.5H2.955A.479.479,0,0,1,2.5,0a.479.479,0,0,1,.455-.5H9.045A.479.479,0,0,1,9.5,0,.479.479,0,0,1,9.045.5Z"
          transform="translate(-10399.5 3874.5)"
          fill="currentColor"
        />
        <path
          id="Line_177"
          data-name="Line 177"
          d="M6.045.5H-.045A.479.479,0,0,1-.5,0,.479.479,0,0,1-.045-.5H6.045A.479.479,0,0,1,6.5,0,.479.479,0,0,1,6.045.5Z"
          transform="translate(-10385.5 3851.5)"
          fill="currentColor"
        />
        <path
          id="Line_181"
          data-name="Line 181"
          d="M6.045.5H-.045A.479.479,0,0,1-.5,0,.479.479,0,0,1-.045-.5H6.045A.479.479,0,0,1,6.5,0,.479.479,0,0,1,6.045.5Z"
          transform="translate(-10385.5 3874.5)"
          fill="currentColor"
        />
      </g>
      <g
        id="Download_Cloud_-_S"
        data-name="Download Cloud - S"
        transform="translate(-10393.518 3859.243)"
      >
        <path
          id="Download_Cloud_-_S-2"
          data-name="Download Cloud - S"
          d="M11,6.68a2.21,2.21,0,0,0,0-.37,2.52,2.52,0,0,0-2.3-2.5A3.71,3.71,0,0,0,2,5.57a2.16,2.16,0,0,0,.71,4.21h7.1A1.8,1.8,0,0,0,11,6.68Zm-3.41.68L6.39,8.52h0l-.16.1a.57.57,0,0,1-.42,0,.48.48,0,0,1-.14-.09h0L4.45,7.36a.54.54,0,0,1,0-.78.56.56,0,0,1,.79,0l.2.2V4.14a.56.56,0,1,1,1.12,0V6.79l.21-.21a.552.552,0,1,1,.78.78Z"
          transform="translate(-0.52 -2.266)"
          fill="currentColor"
        />
      </g>
    </g>
  ),
});
